import Vue from 'vue';

export const request = ({ method, api, data }) => {
    const headers = { 'Content-Type': 'application/json' };

    const instance = Vue.axios.create({
        baseURL: process.env.VUE_APP_HOST,
        headers: headers,
        timeout: 20000,
        withCredentials: true,
    });

    instance.interceptors.response.use(
        (response) => { return response; },
        async (error) => {
            if (error.response) {
                if (error.response.status === 401) {
                    console.log('網路發生錯誤');
                } else {
                    console.log('程式發生問題');
                }
            }
            return Promise.reject(error);
        }
    );

    return instance.request({
        method: method,
        url: api,
        data: data,
        headers: headers,
    }).then((response) => {
        if (response.data.status === 500) {
            throw {
                message: response.data.errorMsg,
                status: 500
            };
        } else if (response.data.status === 400) {
            throw {
                data: response.data.response,
                status: 400
            };
        } else {
            return {
                data: response.data.response,
                status: 200
            };
        }
    });
};
